import * as tslib_1 from "tslib";
import { Component, Input } from '@angular/core';
import { FormControl, FormGroup, FormArray } from '@angular/forms';
import { FormlyFormBuilder } from '../services/formly.form.builder';
import { assignModelValue, isNullOrUndefined, isObject, reverseDeepMerge, getKey, getValueForKey, getFieldModel } from '../utils';
var FormlyForm = (function () {
    function FormlyForm(formlyBuilder) {
        this.formlyBuilder = formlyBuilder;
        this.model = {};
        this.form = new FormGroup({});
        this.fields = [];
        this.buildForm = true;
    }
    FormlyForm.prototype.ngOnChanges = function (changes) {
        if (changes['fields']) {
            this.model = this.model || {};
            this.form = this.form || (new FormGroup({}));
            this.setOptions();
            if (this.buildForm !== false) {
                this.formlyBuilder.buildForm(this.form, this.fields, this.model, this.options);
            }
            this.updateInitialValue();
        }
        else if (changes['model'] && this.fields && this.fields.length > 0) {
            this.form.patchValue(this.model);
        }
    };
    FormlyForm.prototype.fieldModel = function (field) {
        if (field.key && (field.fieldGroup || field.fieldArray)) {
            return getFieldModel(this.model, field, true);
        }
        return this.model;
    };
    FormlyForm.prototype.changeModel = function (event) {
        assignModelValue(this.model, event.key, event.value);
    };
    FormlyForm.prototype.setOptions = function () {
        this.options = this.options || {};
        if (!this.options.resetModel) {
            this.options.resetModel = this.resetModel.bind(this);
        }
        if (!this.options.updateInitialValue) {
            this.options.updateInitialValue = this.updateInitialValue.bind(this);
        }
    };
    FormlyForm.prototype.resetModel = function (model) {
        model = isNullOrUndefined(model) ? this.initialModel : model;
        this.form.patchValue(model);
        this.resetFormGroup(model, this.form);
        this.resetFormModel(model, this.model);
    };
    FormlyForm.prototype.resetFormModel = function (model, formModel, path) {
        if (!isObject(model) && !Array.isArray(model)) {
            return;
        }
        for (var key in formModel) {
            if (!(key in model) || isNullOrUndefined(model[key])) {
                if (!this.form.get((path || []).concat(key))) {
                    delete formModel[key];
                }
            }
        }
        for (var key in model) {
            if (!isNullOrUndefined(model[key])) {
                if (key in formModel) {
                    this.resetFormModel(model[key], formModel[key], (path || []).concat(key));
                }
                else {
                    formModel[key] = model[key];
                }
            }
        }
    };
    FormlyForm.prototype.resetFormGroup = function (model, form, actualKey) {
        for (var controlKey in form.controls) {
            var key = getKey(controlKey, actualKey);
            if (form.controls[controlKey] instanceof FormGroup) {
                this.resetFormGroup(model, form.controls[controlKey], key);
            }
            if (form.controls[controlKey] instanceof FormArray) {
                this.resetFormArray(model, form.controls[controlKey], key);
            }
            if (form.controls[controlKey] instanceof FormControl) {
                form.controls[controlKey].setValue(getValueForKey(model, key));
            }
        }
    };
    FormlyForm.prototype.resetFormArray = function (model, formArray, key) {
        var newValue = getValueForKey(model, key);
        for (var i = formArray.length - 1; i >= 0; i--) {
            if (formArray.at(i) instanceof FormGroup) {
                if (newValue && !isNullOrUndefined(newValue[i])) {
                    this.resetFormGroup(newValue[i], formArray.at(i));
                }
                else {
                    formArray.removeAt(i);
                    var value = getValueForKey(this.model, key);
                    if (Array.isArray(value)) {
                        value.splice(i, 1);
                    }
                }
            }
        }
        if (Array.isArray(newValue) && formArray.length < newValue.length) {
            var remaining = newValue.length - formArray.length;
            var initialLength = formArray.length;
            for (var i = 0; i < remaining; i++) {
                var pos = initialLength + i;
                getValueForKey(this.model, key).push(newValue[pos]);
                formArray.push(new FormGroup({}));
            }
        }
    };
    FormlyForm.prototype.updateInitialValue = function () {
        var obj = reverseDeepMerge(this.form.value, this.model);
        this.initialModel = JSON.parse(JSON.stringify(obj));
    };
    return FormlyForm;
}());
tslib_1.__decorate([
    Input(),
    tslib_1.__metadata("design:type", Object)
], FormlyForm.prototype, "model", void 0);
tslib_1.__decorate([
    Input(),
    tslib_1.__metadata("design:type", FormGroup)
], FormlyForm.prototype, "form", void 0);
tslib_1.__decorate([
    Input(),
    tslib_1.__metadata("design:type", Array)
], FormlyForm.prototype, "fields", void 0);
tslib_1.__decorate([
    Input(),
    tslib_1.__metadata("design:type", Object)
], FormlyForm.prototype, "options", void 0);
tslib_1.__decorate([
    Input(),
    tslib_1.__metadata("design:type", Boolean)
], FormlyForm.prototype, "buildForm", void 0);
FormlyForm = tslib_1.__decorate([
    Component({
        selector: 'formly-form',
        template: "\n    <formly-field *ngFor=\"let field of fields\"\n      [model]=\"fieldModel(field)\" [form]=\"form\"\n      [field]=\"field\" (modelChange)=\"changeModel($event)\"\n      [ngClass]=\"field.className\"\n      [options]=\"options\">\n    </formly-field>\n    <ng-content></ng-content>\n  ",
    }),
    tslib_1.__metadata("design:paramtypes", [FormlyFormBuilder])
], FormlyForm);
export { FormlyForm };
//# sourceMappingURL=formly.form.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng-formly/lib/src/core/src/components/formly.form.js
// module id = 324
// module chunks = 3